<div [id]="bindingId" style="display: grid;">
    <span #contentHost [innerHtml]="content" [ngClass]="class"></span>

    <forge-tooltip *ngIf="showTooltip" placement="bottom" [target]="targetId" [innerHtml]="content"></forge-tooltip>
</div>
